import type { PersonaNavConfig } from './types';

export const navEmployee: PersonaNavConfig = {
  persona: 'employee',
  groups: [
    {
      key: 'my-space',
      label: 'Mon espace',
      items: [
        {
          key: 'my-mission',
          label: 'Ma mission',
          route: '/my/mission',
          icon: 'Briefcase',
          tenantType: 'interim',
          moduleAvailable: 'interim',
        },
        {
          key: 'my-leave',
          label: 'Mes congés',
          route: '/my/leave',
          icon: 'CalendarDays',
          moduleAvailable: 'leave_mgmt',
        },
        {
          key: 'my-timesheets',
          label: 'Mes relevés',
          route: '/my/timesheets',
          icon: 'Clock',
        },
        {
          key: 'my-expenses',
          label: 'Mes notes de frais',
          route: '/my/expenses',
          icon: 'Wallet',
          moduleAvailable: 'expenses',
        },
        {
          key: 'my-payslips',
          label: 'Mes bulletins de paie',
          route: '/my/payslips',
          icon: 'FileText',
        },
        {
          key: 'my-documents',
          label: 'Mes documents',
          route: '/my/documents',
          icon: 'Folder',
        },
      ],
    },
    {
      key: 'bottom',
      items: [
        {
          key: 'inbox',
          label: 'Boîte de tâches',
          route: '/inbox',
          icon: 'Inbox',
          badgeSource: 'inbox',
        },
      ],
    },
  ],
};
